import {
  ListViewProvider,
  useListView,
} from '../../../data-administration/data-admininstration-list/core/ListViewProvider'
import { QueryRequestProvider } from '../../../data-administration/data-admininstration-list/core/QueryRequestProvider'
import {
  QueryResponseProvider,
  useQueryResponse,
} from '../../../data-administration/data-admininstration-list/core/QueryResponseProvider'
import { isNotEmpty, KTCard, KTIcon, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { useEffect, useState } from 'react'
import { useAuth } from '../../../../auth'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import { useQuery } from 'react-query'
import {
  createUser,
  getUserById,
  updateUser,
} from '../../../data-administration/data-admininstration-list/core/_requests'
import { FieldArray, FormikProvider, useFormik } from 'formik'
import * as Yup from 'yup'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import clsx from 'clsx'
import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload'
import { UsersListLoading } from '../../../data-administration/data-admininstration-list/components/loading/UsersListLoading'
import React from 'react'
import { inputForm } from '../../../../../../_metronic/helpers/inputForm'
import { SuccessModal } from './successToast'

const editUserSchema = (data) =>
  Yup.object().shape({
    // name: Yup.string()
    //   .min(3, 'Minimum 3 symbols')
    //   .max(50, 'Maximum 50 symbols')
    //   .required('Name is required'),
    // rigid: Yup.string().when('inCategoryId', {
    //   is: () => data?.some((item) => item.value === 'DIVERSION_FACILITY'),
    //   then: (schema) => schema.required('Rigid required'), // itemId is required if categoryId exists
    //   otherwise: (schema) => schema.notRequired(), // No validation if categoryId is absent
    // }),
    // country: Yup.string().required('Country required'),
    // state: Yup.string().required('state required'),
    // city: Yup.string().required('city required'),
    // inCategoryId: Yup.string().required('Select facility type'),
    // latitute: Yup.number().required('Product Weight required'),
    // longitute: Yup.number().required('Dimension required'),
    // ...((data.length &&
    //   data?.some((item: {label: string; value: string}) => item.value === 'CONVERTER') &&
    //   {}) || {
    //   facilityManager: Yup.array()
    //     .of(
    //       Yup.object().shape({
    //         label: Yup.string().required('Label is required'),
    //         value: Yup.string().required('Value is required'),
    //       })
    //     )
    //     .min(1, 'Facility Manager required'),
    //   facilityStaff: Yup.string().required('Mobile App Users'),
    // }),
    productInformation: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).length;
        return wordCount <= 50;
      }),
    productName: Yup.string()
      .test('word-count', 'Maximum 10 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 10;
      }),
    skunName: Yup.string()
      .test('word-count', 'Maximum 10 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 10;
      }),
    aboutBrand: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
    aboutItem: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
    packaging: Yup.string()
      .test('word-count', 'Maximum 10 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 10;
      }),
    proofOfIdentity_num: Yup.string()
      .test('word-count', 'Maximum 10 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 10;
      }),
    proofEstablishment_num: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
    reuse: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
    repair: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
    recyle: Yup.string()
      .test('word-count', 'Maximum 50 words allowed', function (value) {
        if (!value) return true;
        const wordCount = value.trim().split(/\s+/).filter(word => word.length > 0).length;
        return wordCount <= 50;
      }),
  })

const UsersList = ({ user = {}, isUserLoading = false }: any) => {
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()
  const initialState = [
    {
      processId: '',
      processName: '',
      faciliyId: '',
      facilityName: '',
      address: '',
      country: '',
      certifications: '',
      image: '',
      action: false,
    },
  ]

  const [userForEdit] = useState<any>({
    ...user,
    defaultDynamic: user?.tests?.[0]?.parameters || initialState,
  })

  const [finishedGoodsList, setFinishedGoodsList] = useState<any>([])
  const [selectedInCategoryDropdown, setselectedInCategoryDropdown] = useState(
    /*  user?.facilityType?.map((x) => ({...x, label: x?.name || x})) ||  */[]
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)

  useEffect(() => {
    if (user?.facilityType) {
      const changeData = user.facilityType.map((x) => ({
        label: '',
        value: x.name || x,
      }))
      setselectedInCategoryDropdown(changeData)
    }
  }, [user])

  const [rawMaterialList, setRawMaterialList] = useState<any>([])

  const { responseData: categoryTypeList } = useFetchCommon({
    api: 'clients/101212/categories?page=0&size=10',
    isDropDown: true,
  })

  const formik: any = useFormik({
    initialValues: userForEdit,
    validationSchema: editUserSchema(selectedInCategoryDropdown),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const payload = {
          categoryId: values.categoryId,
          itemId: values.itemId,
          franchiseId: '',
          bomDetail: [],
          productName: values.productName,
          skuName: values.skuName,
          description: values.description,
          dimension: values.dimension,
          weight: values.weight,
          productImages: [
            {
              url: values.image1 || '',
              image: 'image1.png',
            },
            {
              url: values.image2 || '',

              image: 'image2.png',
            },
            {
              url: values.image3 || '',
              image: 'image3.png',
            },
            {
              url: values.image4 || '',
              image: 'image4.png',
            },
          ],
          bom: '',
          aboutBrand: values.aboutBrand,
          aboutItem: values.aboutItem,
          packaging: values.packaging,
          processes: values.defaultDynamic.map((eachDynamic, eachInd) => ({
            ...eachDynamic,
            facilityName:
              facilityDropDown.filter((x: any) => x.value === eachDynamic.faciliyId)?.[0]?.label ??
              '',
            processName:
              diversionDetails.filter((x: any) => x.value === eachDynamic.processId)[0]?.label ??
              '',
          })),

          certificates: [],
          recycleInfo: [
            {
              url: values.recycleUrl,
              image: values.recyleImage,
              text: values.recyle,
            },
          ],
          reuseInfo: [
            {
              url: values.reuseUrl,
              image: values.reuseImage,
              text: values.reuse,
            },
          ],
          repairInfo: [
            {
              url: values.repairUrl,
              image: values.repairImage,
              text: values.repair,
            },
          ],
          isSaveCO2: values.isSaveCO2 || false,
          isSaveEnergy: values.isSaveEnergy || false,
          isSaveTrees: values.isSaveTrees || false,
          isSaveWater: values.isSaveWater || false,
          socialImpact: [
            {
              url: values.socialImpact1 || '',
              image: 'socialImpact',
            },
            {
              url: values.socialImpact2 || '',
              image: 'socialImpact',
            },
            {
              url: values.socialImpact3 || '',
              image: 'socialImpact',
            },
            {
              url: values.socialImpact4 || '',
              image: 'socialImpact',
            },
          ],
        }
        console.log({ payloads: payload.processes, facilityDropDown, diversionDetails })
        if (isNotEmpty(values.id)) {
          await updateUser(payload, `users/${values.id}/update`)
          successToast('Modified')
          setShowSuccessModal(true)
          cancel(true)
        } else {
          await createUser(payload, 'dpp/create')
          successToast('Added')
          setShowSuccessModal(true)
          cancel(true)
        }
      } catch (ex) {
        errorToast('Somethig Went Wrong')
        console.error(ex)
      } finally {
        setSubmitting(true)
      }
    },
  })
  const { responseData: itemListApi } = useFetchCommon({
    api: `categories/${formik.values.categoryId}/items`,
    isDropDown: true,
    isEnabled: !!formik.values.categoryId,
  })
  const { responseData: diversionDetails } = useFetchCommon({
    isDropDown: true,
    api: 'materialProcesses?page=0&size=10',
  })

  const { data: resp } = useQuery(
    'user_list',
    () => getUserById(null, 'certifications?page=0&size=10&status=ACTIVE'),
    {
      cacheTime: 0,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
      enabled: true, // Set this to true to run the query once
    }
  )

  useEffect(() => {
    if (resp?.length) {
      const tempAllCategories = resp.map((eachRes) => {
        return {
          label: eachRes?.certificationName || '',
          value: eachRes.id,
        }
      })
      setFinishedGoodsList(tempAllCategories)
    }
  }, [resp])

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const [selectedOutCategoryDropdown, setselectedOutCategoryDropdown] = useState(
    user?.facilityStaff?.map((x) => ({ ...x, label: x.name || x })) || []
  )
  const { responseData: facilityTypeList } = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT',
    label: ['personalDetails', 'name'],
    isDropDown: false,
  })
  const [facilityDropDown, setFacilityDropDown] = useState<any>([])

  useEffect(() => {
    if (facilityTypeList.length) {
      setFacilityDropDown(
        facilityTypeList.map((eachFacility, eachInd) => ({
          label: eachFacility?.personalDetails?.name ?? '',
          value: eachFacility?.id ?? '',
        }))
      )
    }
  }, [facilityTypeList])

  const makeSelectDropDown = (name = '', options: any = [], showTick = true, props = {}) => {
    return (
      <>
        <select
          style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dddddd',
            color: '#000000', // Text color for selected option
          }}
          className={clsx(
            'form-control form-control-solid mb-3 mb-lg-0',
            { 'is-invalid': formik.touched[name] && formik.errors[name] },
            {
              'is-valid': (showTick && formik.touched[name] && !formik.errors[name]) || '',
            }
          )}
          {...formik.getFieldProps(name)}
          {...props}
        >
          <option value=''>Select one...</option>
          {options.map((eachOption, eachInd) => (
            <option key={eachInd + 1 + ''} value={eachOption.value}>
              {eachOption.label}
            </option>
          ))}
        </select>
        {formik.errors[name] && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors[name]}</span>
            </div>
          </div>
        )}
      </>
    )
  }

  const impactCheckBox = [
    {
      label: 'GHG Value',
      value: 'isSaveCO2',
    },
    {
      label: 'Energy Value',
      value: 'isSaveEnergy',
    },
    {
      label: 'Water Value',
      value: 'isSaveWater',
    },
    {
      label: 'Trees Value',
      value: 'isSaveTrees',
    },
  ]

  const allFields = [
    {
      sectionTitle: 'Reuse Information',
      fields: [
        {
          type: 'input',
          label: 'Reuse Information',
          name: 'reuse',
          placeholder: 'Enter Reuse Information',
        },
        {
          type: 'image',
          name: 'reuseImage',
          label: 'Upload image',
          required: false,
        },
        {
          type: 'input',
          label: 'Enter Url',
          name: 'reuseUrl',
          placeholder: 'Enter URL',
        },
      ],
    },
    {
      sectionTitle: 'Repair Information',
      fields: [
        {
          type: 'input',
          label: 'Repair Information',
          name: 'repair',
          placeholder: 'Enter Repair Information',
        },
        {
          type: 'image',
          name: 'repairImage',
          label: 'Upload image',
          required: true,
        },
        {
          type: 'input',
          label: 'Enter URL',
          name: 'repairUrl',
          placeholder: 'Enter URL',
        },
      ],
    },
    {
      sectionTitle: 'Recycling Information',
      fields: [
        {
          type: 'input',
          label: 'Recycling Information',
          name: 'recyle',
          placeholder: 'Enter Recycling Information',
        },
        {
          type: 'image',
          name: 'recyleImage',
          label: 'Upload image',
          required: true,
        },
        {
          type: 'input',
          label: 'Enter URL',
          name: 'recycleUrl',
          placeholder: 'Enter URL',
        },
      ],
    },
  ]

  const uploadImageFirst = [
    {
      label: 'Product Image 1',
      name: 'image1',
    },
    {
      label: 'Product Image 2',
      name: 'image2',
    },
    {
      label: 'Product Image 3',
      name: 'image3',
    },
    {
      label: 'Product Image 4',
      name: 'image4',
    },
  ]
  const uploadImageSecond = [
    {
      label: 'Upload image',
      name: 'socialImpact1',
    },
    {
      label: 'Upload image',
      name: 'socialImpact2',
    },
    {
      label: 'Upload image',
      name: 'socialImpact3',
    },
    {
      label: 'Upload image',
      name: 'socialImpact4',
    },
  ]
  // const commonForm = (id: number, data: any) => {
  //   return (
  //     <div>







  //       <div className=''>
  //         {/* Row 1: 5 items inline */}
  //         <div className='grid grid-cols-5 gap-4'>
  //           <div className='fv-row mb-7'>
  //             <label className='fw-bold fs-6 mb-2'>Select process</label>
  //             {makeSelectDropDown(`defaultDynamic[${id}].processId`, diversionDetails)}
  //           </div>
  //           <div className='fv-row mb-7'>
  //             <label className='fw-bold fs-6 mb-2'>Select facility</label>
  //             {makeSelectDropDown(`defaultDynamic[${id}].faciliyId`, facilityDropDown, true, {
  //               onChange: (e: React.ChangeEvent<HTMLSelectElement>) => {
  //                 const selectedId = e.target.value
  //                 const selectedFacility = facilityTypeList.find((f) => f.id === selectedId)

  //                 formik.setFieldValue(`defaultDynamic[${id}].faciliyId`, selectedId)

  //                 if (selectedFacility) {
  //                   // Set address from selected facility
  //                   formik.setFieldValue(
  //                     `defaultDynamic[${id}].address`,
  //                     selectedFacility?.address?.street || ''
  //                   )
  //                   formik.setFieldValue(
  //                     `defaultDynamic[${id}].country`,
  //                     selectedFacility?.address?.country || ''
  //                   )
  //                   // Combine certifications as a single string (e.g., "ISO 22095, GRS")
  //                   const certString =
  //                     selectedFacility?.certifications
  //                       ?.map((c) => c.certificationName)
  //                       .join(', ') || ''

  //                   formik.setFieldValue(`defaultDynamic[${id}].certifications`, certString)
  //                 }
  //               },
  //             })}
  //           </div>
  //           <div>
  //             {inputForm({
  //               id: id + 1 + '',
  //               label: `Enter Address`,
  //               name: `defaultDynamic[${id}].address`,
  //               placeholder: 'Add Address',
  //               formik,
  //               required: false,
  //               readOnly: true,
  //             })}
  //           </div>
  //           <div>
  //             <UploadImage
  //               // name='proofEstablishment'
  //               name={`defaultDynamic[${id}].image`}
  //               formik={formik}
  //               label='Upload image'
  //             />
  //           </div>
  //           <div className='form-check form-check-solid '>
  //             <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='deactivate'>
  //               Show in Dpp
  //             </label>
  //             <input
  //               name={`defaultDynamic[${id}].action`}
  //               className='form-check-input'
  //               type='checkbox'
  //               {...formik.getFieldProps(`defaultDynamic[${id}].action`)}
  //             />
  //           </div>
  //         </div>

  //         {/* Row 2: 2 items */}
  //         <div className='grid grid-cols-5 gap-4'>
  //           <div>
  //             {inputForm({
  //               label: 'Country',
  //               name: `defaultDynamic[${id}].country`,
  //               placeholder: 'Enter Country',
  //               formik,
  //               required: false,
  //               readOnly: true,
  //             })}
  //           </div>
  //           <div>
  //             {' '}
  //             {inputForm({
  //               label: 'Certifications',
  //               name: `defaultDynamic[${id}].certifications`,
  //               formik,
  //               placeholder: 'Enter Certifications',
  //               required: false,
  //               readOnly: true,
  //             })}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  const commonForm = (id: number, data: any) => {
    return (
      <div>
        <div className=''>
          {/* Single row with all fields inline */}
          <div className='grid grid-cols-6 gap-4'>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Select process</label>
              {makeSelectDropDown(`defaultDynamic[${id}].processId`, diversionDetails)}
            </div>

            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Select facility</label>
              {makeSelectDropDown(`defaultDynamic[${id}].faciliyId`, facilityDropDown, true, {
                onChange: (e: React.ChangeEvent<HTMLSelectElement>) => {
                  const selectedId = e.target.value
                  const selectedFacility = facilityTypeList.find((f) => f.id === selectedId)

                  formik.setFieldValue(`defaultDynamic[${id}].faciliyId`, selectedId)

                  if (selectedFacility) {
                    formik.setFieldValue(
                      `defaultDynamic[${id}].country`,
                      selectedFacility?.address?.country || ''
                    )
                    const certString =
                      selectedFacility?.certifications
                        ?.map((c) => c.certificationName)
                        .join(', ') || ''

                    formik.setFieldValue(`defaultDynamic[${id}].certifications`, certString)
                  }
                },
              })}
            </div>

            <div>
              {inputForm({
                label: 'Country',
                name: `defaultDynamic[${id}].country`,
                placeholder: 'Enter Country',
                formik,
                required: false,
                readOnly: true,
              })}
            </div>

            <div style={{ marginLeft: '15px' }}>
              <UploadImage
                name={`defaultDynamic[${id}].image`}
                formik={formik}
                label='Upload image'
              />
            </div>

            <div>
              {inputForm({
                label: 'Certifications',
                name: `defaultDynamic[${id}].certifications`,
                formik,
                placeholder: 'Enter Certifications',
                required: false,
                readOnly: true,
              })}
            </div>

            <div className='form-check form-check-solid' style={{ marginTop: '25px' }}>
              <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='deactivate'>
                Show in Dpp
              </label>
              <input
                name={`defaultDynamic[${id}].action`}
                className='form-check-input'
                type='checkbox'
                {...formik.getFieldProps(`defaultDynamic[${id}].action`)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <KTCard>
      <div className='p-6'>
        <form
          id='kt_modal_add_user_form'
          className='form'
          onSubmit={formik.handleSubmit}
          noValidate
        >

          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dddddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            maxWidth: '100%',
            margin: '20px auto',
            // fontFamily: 'Arial, sans-serif'
          }}>
            <h2 style={{
              textAlign: "center",
              fontSize: '18px',
              fontWeight: '600',
              color: '#333333',
            }}>
              Product Information
            </h2>
          </div>

          <div className='grid grid-cols-2 gap-2'>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Category</label>
              {makeSelectDropDown('categoryId', categoryTypeList, false)}
            </div>
            <div className='fv-row mb-7'>
              <label className='fw-bold fs-6 mb-2'>Item</label>
              {/* {makeSelectDropDown('weightScale', weightScaleList, false)} */}
              {makeSelectDropDown('itemId', itemListApi, false)}
            </div>
          </div>
          {/* <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              label: 'Product Information',
              name: 'productInformation',
              formik,
              placeholder: 'Enter Product Information',
            })}

           


            

            {inputForm({
              label: 'Product Name',
              name: 'productName',
              formik,
              placeholder: 'Enter Product Name',
            })}
          </div> */}

          <div className='grid grid-cols-2 gap-2'>
            <div>
              {inputForm({
                label: 'Product Information',
                name: 'productInformation',
                formik,
                placeholder: 'Enter Product Information',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.productInformation
                  ? `${formik.values.productInformation.trim().split(/\s+/).filter(word => word.length > 0).length}/50 words`
                  : 'Max 50 words'
                }
              </div>
            </div>

            <div>
              {inputForm({
                label: 'Product Name',
                name: 'productName',
                formik,
                placeholder: 'Enter Product Name',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.productName
                  ? `${formik.values.productName.trim().split(/\s+/).filter(word => word.length > 0).length}/10 words`
                  : 'Max 10 words'
                }
              </div>
            </div>
          </div>


          {/* <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              label: 'SKU name',
              name: 'skunName',
              formik,
              placeholder: 'Enter SKU name',
            })}
            {inputForm({
              label: 'Product Description',
              name: 'description',
              formik,
              placeholder: 'Enter Product Description',
            })}
          </div> */}




          <div className='grid grid-cols-2 gap-2'>
            <div>
              {inputForm({
                label: 'SKU name',
                name: 'skunName',
                formik,
                placeholder: 'Enter SKU name',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.skunName
                  ? `${formik.values.skunName.trim().split(/\s+/).filter(word => word.length > 0).length}/10 words`
                  : 'Max 10 words'
                }
              </div>
            </div>

            {inputForm({
              label: 'Product Description',
              name: 'description',
              formik,
              placeholder: 'Enter Product Description',
            })}
          </div>




          <div className='grid grid-cols-4 gap-2'>
            {uploadImageFirst.map((eachUploadImg, eachInd) => (
              <React.Fragment key={eachInd + 1 + ''}>
                <UploadImage
                  name={eachUploadImg.name}
                  required={false}
                  formik={formik}
                  label={eachUploadImg.label}
                />
              </React.Fragment>
            ))}
          </div>
          <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              label: 'Product Weight',
              name: 'weight',
              formik,
              placeholder: 'Enter Product Weight',
            })}
            {inputForm({
              label: 'Dimension',
              name: 'dimension',
              placeholder: 'Enter Dimension',
              formik,
            })}
          </div>
          {/* <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              required: false,
              label: 'About Brand (Optional)',
              name: 'aboutBrand',
              formik,
              placeholder: 'Enter only values',
            })}
            {inputForm({
              required: false,
              label: 'About Product (Optional)',
              name: 'aboutItem',
              formik,
              placeholder: 'Enter only values',
            })}
          </div> */}

          <div className='grid grid-cols-2 gap-2'>
            <div>
              {inputForm({
                required: false,
                label: 'About Brand (Optional)',
                name: 'aboutBrand',
                formik,
                placeholder: 'Describe what the brand stands for',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.aboutBrand
                  ? `${formik.values.aboutBrand.trim().split(/\s+/).filter(word => word.length > 0).length}/50 words`
                  : 'Max 50 words'
                }
              </div>
            </div>

            <div>
              {inputForm({
                required: false,
                label: 'About Product (Optional)',
                name: 'aboutItem',
                formik,
                placeholder: 'Describe the USP of the product',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.aboutItem
                  ? `${formik.values.aboutItem.trim().split(/\s+/).filter(word => word.length > 0).length}/50 words`
                  : 'Max 50 words'
                }
              </div>
            </div>
          </div>




          {/* <div className='grid grid-cols-2 gap-2'>
            {inputForm({
              required: false,
              label: 'Packaging Information',
              name: 'packaging',
              formik,
              placeholder: 'Enter Packaging Information',
            })}
            {inputForm({
              required: false,
              className: 'fw-bold fs-7 mb-2',
              label: 'Generic Name',
              name: 'proofOfIdentity_num',
              formik,
              placeholder: 'Enter Generic Name',
            })}
          </div> */}



          <div className='grid grid-cols-2 gap-2'>
            <div>
              {inputForm({
                required: false,
                label: 'Packaging Information',
                name: 'packaging',
                formik,
                placeholder: 'Enter Packaging Information',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.packaging
                  ? `${formik.values.packaging.trim().split(/\s+/).filter(word => word.length > 0).length}/10 words`
                  : 'Max 10 words'
                }
              </div>
            </div>

            <div>
              {inputForm({
                required: false,
                className: 'fw-bold fs-7 mb-2',
                label: 'Generic Name',
                name: 'proofOfIdentity_num',
                formik,
                placeholder: 'Enter Generic Name',
              })}
              <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                {formik.values.proofOfIdentity_num
                  ? `${formik.values.proofOfIdentity_num.trim().split(/\s+/).filter(word => word.length > 0).length}/10 words`
                  : 'Max 10 words'
                }
              </div>
            </div>
          </div>


          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dddddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            maxWidth: '100%',
            margin: '20px auto',
            // fontFamily: 'Arial, sans-serif'
          }}>
            <h2 style={{
              textAlign: "center",
              fontSize: '18px',
              fontWeight: '600',
              color: '#333333',
            }}>
              Supply chain Information
            </h2>
          </div>




          <div className='card'>
            <FormikProvider value={formik}>
              {/* <FieldArray
                name='defaultDynamic'
                render={(arrayHelpers) => {
                  const data = formik.values.defaultDynamic
                  return (
                    <div className='card p-4'>
                      {data?.map((x, index) => (
                        <div key={index}>
                          {commonForm(index, formik.values.defaultDynamic)}
                          <button
                            disabled={formik.values.defaultDynamic?.length === 1}
                            type='button'
                            onClick={() => arrayHelpers.remove(index)}
                            className='deleteButton'
                          >
                            {data.length !== 1 && <KTIcon iconName='trash' className='fs-2' />}
                          </button>
                          {formik.values.defaultDynamic.length !== 1 ? <hr /> : ''}
                        </div>
                      ))}
                      <button type='button' onClick={() => arrayHelpers.push(initialState[0])}>
                        Add More
                      </button>
                    </div>
                  )
                }}
              /> */}
              <FieldArray
                name='defaultDynamic'
                render={(arrayHelpers) => {
                  const data = formik.values.defaultDynamic
                  return (
                    <div className='card p-4'>
                      {data?.map((x, index) => (
                        <div key={index}>
                          {commonForm(index, formik.values.defaultDynamic)}
                          <button
                            disabled={formik.values.defaultDynamic?.length === 1}
                            type='button'
                            onClick={() => arrayHelpers.remove(index)}
                            className='deleteButton'
                          >
                            {data.length !== 1 && <KTIcon iconName='trash' className='fs-2' />}
                          </button>
                          {formik.values.defaultDynamic.length !== 1 ? <hr /> : ''}
                        </div>
                      ))}
                      <div style={{ textAlign: 'left', marginTop: '10px' }}>
                        <button
                          type='button'
                          onClick={() => arrayHelpers.push(initialState[0])}
                          className='btn btn-primary'
                          style={{ backgroundColor: '#333333', border: 'none', padding: '10px 20px', borderRadius: '5px', color: 'white', maxWidth: '150px' }}
                        >
                          Add More
                        </button>
                      </div>
                    </div>
                  )
                }}
              />
            </FormikProvider>
          </div>

          <br />





          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dddddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            maxWidth: '100%',
            margin: '20px auto',
            // fontFamily: 'Arial, sans-serif'
          }}>
            <h2 style={{
              textAlign: "center",
              fontSize: '18px',
              fontWeight: '600',
              color: '#333333',
            }}>
              Impact Information
            </h2>
          </div>




          <div className='card p-4'>
            <div className='grid grid-cols-2 gap-2'>
              <div className='fv-row mb-7'>
                <label
                  className='form-check-label text-black fw-bold ps-2 fs-6'
                  htmlFor='deactivate'
                >
                  Show Climate Impact values in DPP
                </label>
                <div className='grid grid-cols-2 gap-2 pt-2'>
                  {impactCheckBox.map((eachImpactCheckBox, eachInd) => (
                    <div key={eachInd + 1 + ''} className='form-check form-check-solid '>
                      <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='deactivate'>
                        {eachImpactCheckBox.label}
                      </label>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        {...formik.getFieldProps(eachImpactCheckBox.value)}
                      />
                    </div>
                  ))}
                </div>
              </div>
              {/* {inputForm({
                required: false,
                label: 'Socal Impact',
                name: 'proofEstablishment_num',
                formik,
                placeholder: 'Enter Socal Impact',
              })} */}
              <div>
                {inputForm({
                  required: false,
                  label: 'Social Impact',
                  name: 'proofEstablishment_num',
                  formik,
                  placeholder: 'Enter Social Impact',
                })}
                <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                  {formik.values.proofEstablishment_num
                    ? `${formik.values.proofEstablishment_num.trim().split(/\s+/).filter(word => word.length > 0).length}/50 words`
                    : 'Max 50 words'
                  }
                </div>
              </div>
            </div>
            <div className='grid grid-cols-4 gap-2'>
              {uploadImageSecond.map((eachUploadImg, eachInd) => (
                <React.Fragment key={eachInd + 1 + ''}>
                  <UploadImage
                    name={eachUploadImg.name}
                    required={false}
                    formik={formik}
                    label={eachUploadImg.label}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
          <br />



          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #dddddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            maxWidth: '100%',
            margin: '20px auto',
            fontFamily: 'Arial, sans-serif'
          }}>
            <h2 style={{
              textAlign: "center",
              fontSize: '18px',
              fontWeight: '600',
              color: '#333333',
            }}>
              Lifecycle Information
            </h2>
          </div>


          <div className='card p-4'>
            {/* <h2 className='text-lg font-semibold mb-2'>LIFECYCLE INFORMATION</h2> */}
            {allFields.map((section, sectionIndex) => (
              <div className='mb-6' key={sectionIndex}>
                <div className='grid grid-cols-3 gap-2'>
                  {section.fields.map((field, fieldIndex) => {
                    if (field.type === 'input') {
                      return (
                        // <React.Fragment key={`${sectionIndex}-${fieldIndex}`}>
                        //   {inputForm({
                        //     label: field.label,
                        //     name: field.name,
                        //     placeholder: field.placeholder,
                        //     formik,
                        //   })}
                        // </React.Fragment>
                        <div key={`${sectionIndex}-${fieldIndex}`}>
                          {inputForm({
                            label: field.label,
                            name: field.name,
                            placeholder: field.placeholder,
                            formik,
                          })}
                          {(field.name === 'reuse' || field.name === 'repair' || field.name === 'recyle') && (
                            <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '10px' }}>
                              {formik.values[field.name]
                                ? `${formik.values[field.name].trim().split(/\s+/).filter(word => word.length > 0).length}/50 words`
                                : 'Max 50 words'
                              }
                            </div>
                          )}
                        </div>
                      )
                    }

                    if (field.type === 'image') {
                      return (
                        <UploadImage
                          key={`${sectionIndex}-${fieldIndex}`}
                          name={field.name}
                          label={field.label}
                          formik={formik}
                          required={field.required}
                        />
                      )
                    }

                    return null
                  })}
                </div>
              </div>
            ))}
          </div>

          <div className='text-center pt-15'>
            <button
              type='reset'
              onClick={() => cancel()}
              className='btn btn-light me-3'
              data-kt-users-modal-action='cancel'
              disabled={formik.isSubmitting || isUserLoading}
            >
              Discard
            </button>
            <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              style={{ backgroundColor: '#333333' }}
              disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
            >
              <span className='indicator-label'>Submit</span>
              {(formik.isSubmitting || isUserLoading) && (
                <span className='indicator-progress'>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
        {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
        {showSuccessModal && <SuccessModal close={() => setShowSuccessModal(false)} />}
      </div>
    </KTCard>
  )
}

const CreateDppWrapper = () => (
  <QueryRequestProvider initialValue={{ initialApi: 'clients/101212/categories' }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <UsersList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { CreateDppWrapper }
